import api from './api';
export default {
    get: (globalObjectKey) => api.get(`/api/report/projectdata/${globalObjectKey}`),
};